import { CheckCircleTwoTone, DisconnectOutlined } from '@ant-design/icons';
import { Alert, Avatar, Card, Col, Row } from 'antd';
import { message } from '@/components/Message';
import { ModalProps } from 'antd/es/modal';
import React, { useEffect, useState } from 'react';
import AsyncWrapper from '@/components/AsyncWrapper';
import Modal from '@/components/Modal';
import PosButton from '@/components/PosButton';
import { bindMoremeClientToUser, useFetchMoremeClientList } from '@/models/moreme';
import { User } from '@/models/user';

type Props = {
  user: User;
  onBindSuccess: (updatedUser: User) => void;
};

export const MoremeClientBinder: React.FC<Props> = ({ user, onBindSuccess }: Props) => {
  const [currentQuery, updateQueryOrigin] = useState({
    page: 1,
    // sort: 'last_visit_time',
    // userName: undefined,
  });

  const { payload, send, loaded, loading, error } = useFetchMoremeClientList();

  useEffect(() => {
    send({
      params: {
        ...currentQuery,
      },
    }).then();
  }, [currentQuery]);

  return (
    <>
      <AsyncWrapper render={loaded} loading={loading} error={error}>
        {() => (
          <>
            <Alert message={<>仅展示尚未绑定的检测仪客户</>} style={{ marginBottom: 12 }} />
            <Row gutter={[12, 12]}>
              {payload.list
                .filter(moremeClient => !Boolean(moremeClient.userId))
                .map(moremeClient => {
                  const moremeClientHasBindUser = Boolean(moremeClient.userId);
                  const currentUserHasBindMoremeClient = Boolean(user.moremeCid);
                  return (
                    <Col key={moremeClient.id} span={8}>
                      <Card
                        size="small"
                        actions={[
                          <PosButton
                            key={'1'}
                            type={moremeClientHasBindUser ? 'primary' : 'secondary'}
                            icon={
                              moremeClientHasBindUser ? (
                                <CheckCircleTwoTone />
                              ) : (
                                <DisconnectOutlined />
                              )
                            }
                            onClick={() => {
                              Modal.confirm({
                                type: moremeClientHasBindUser ? 'error' : 'warning',
                                title: '确认绑定到当前客户吗？',
                                content: '该操作将连接检测仪客户至当前会话客户',
                                onOk: async () => {
                                  const updatedUser = await bindMoremeClientToUser({
                                    username: user.username,
                                    moremeCid: moremeClient.id,
                                  });
                                  onBindSuccess(updatedUser);
                                },
                              });
                            }}>
                            {moremeClientHasBindUser ? '已绑定' : '绑定该客户'}
                          </PosButton>,
                        ]}>
                        <Card.Meta
                          avatar={<Avatar size={60} src={moremeClient.image} />}
                          title={moremeClient.cname}
                          description={moremeClient.createtime}
                        />
                      </Card>
                    </Col>
                  );
                })}
            </Row>
          </>
        )

        // <Table
        //   bordered
        //   scroll={{ x: 'max-content' }}
        //   loading={loading}
        //   dataSource={payload.list}
        //   columns={columns}
        //   rowKey={`id`}
        //   pagination={{
        //     ...payload.page,
        //     size: 'default',
        //     showSizeChanger: false,
        //     onChange: page => {
        //       // updateQuery({ page });
        //     },
        //   }}
        // />
        }
      </AsyncWrapper>
    </>
  );
};

type ModalBinderProps = Props & ModalProps;
export const MoremeClientModalBinder: React.FC<ModalBinderProps> = ({
  user,
  onBindSuccess,
  open,
  onCancel,
}: ModalBinderProps) => {
  return (
    <Modal title="选择检测仪客户" width={750} open={open} onCancel={onCancel}>
      <MoremeClientBinder
        user={user}
        onBindSuccess={updatedUser => {
          message.success('绑定成功');
          onBindSuccess(updatedUser);
        }}
      />
    </Modal>
  );
};
